import { unescapeHtml } from 'utils/htmlSymbolHandling'

const AddAlertDialogParamsDefinitions = [
  {
    section: 'settings',
    tag: 'useEmail',
    label: 'Email',
    type: 'boolean',
  },
  {
    section: 'settings',
    tag: 'useSms',
    label: 'SMS',
    type: 'custom',
  },
  {
    section: 'settings',
    tag: 'useDashboards',
    label: 'Dashboard',
    type: 'boolean',
  },
  {
    section: 'alertDetails',
    tag: 'name',
    label: 'Alert Type',
    type: 'custom',
  },
  {
    section: 'alertDetails',
    tag: 'severity',
    label: 'Severity',
    type: 'custom',
  },
  {
    section: 'alertDetails',
    tag: 'phase',
    label: 'Phase',
    type: 'custom',
  },
  {
    section: 'alertDetails',
    tag: 'rig',
    label: 'Rig',
    type: 'custom',
  },
  {
    section: 'alertDetails',
    tag: 'min',
    label: 'Minimum',
    type: 'numeric',
    precision: 2,
  },
  {
    section: 'alertDetails',
    tag: 'max',
    label: 'Maximum',
    type: 'numeric',
    precision: 2,
  },
  {
    section: 'depthLimits',
    tag: 'minDepth',
    label: 'Min Depth',
    type: 'custom',
  },
  {
    section: 'depthLimits',
    tag: 'maxDepth',
    label: 'Max Depth',
    type: 'custom',
  },
  {
    section: 'options',
    tag: 'silenceAlert',
    label: 'Silence Alert',
    type: 'boolean',
  },
  {
    section: 'options',
    tag: 'ignoreProjections',
    label: 'Include Projections',
    type: 'boolean',
  },
]

export function getDetails(row, base, shouldShowDepths, showProjections, renderers = {}) {
  const details = {
    settings: [],
    alertDetails: [],
    depthLimits: [],
    options: [],
  }

  if (!row || typeof row !== 'object') return details

  AddAlertDialogParamsDefinitions.forEach((field, index) => {
    if (field.tag === 'min' && !base?.useMin) return
    if (field.tag === 'max' && !base?.useMax) return
    if (field.section === 'depthLimits' && !shouldShowDepths) return
    if (field.tag === 'ignoreProjections' && !showProjections) return

    const value = field.tag === 'ignoreProjections' ? !row.ignoreProjections : (row[field.tag] ?? '')

    details[field.section].push({
      ...field,
      id: index,
      value,
      ...(field.type === 'custom' && {
        render: renderers[field.tag],
      }),
    })
  })

  return details
}

export function getAlertTypePatch(value, defaultAlerts) {
  const name = unescapeHtml(value ?? '')
  const selectedBase = defaultAlerts?.find((alert) => alert.name === name)

  return {
    name,
    min: selectedBase?.min ?? '',
    max: selectedBase?.max ?? '',
  }
}

export default AddAlertDialogParamsDefinitions
